import PropTypes from "prop-types";
import { useId } from "react";

import { Icon } from "../../components/BaseComponents/Icon";

export const ClockIcon = ({
	useGradient = false, // default: solid fill
	from = "#0756C0",
	to = "#2F97F4",
	color = "white", // solid color when not using gradient
	...props
}) => {
	const gradId = useId();

	return (
		<Icon viewBox="0 0 16 16" {...props}>
			{useGradient && (
				<defs>
					<linearGradient
						id={gradId}
						x1="8"
						y1="0"
						x2="8"
						y2="16"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor={from} />
						<stop offset="1" stopColor={to} />
					</linearGradient>
				</defs>
			)}

			<path
				d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM12.6667 8.66667H8C7.63133 8.66667 7.33333 8.368 7.33333 8V3.33333C7.33333 2.96533 7.63133 2.66667 8 2.66667C8.36867 2.66667 8.66667 2.96533 8.66667 3.33333V7.33333H12.6667C13.0353 7.33333 13.3333 7.632 13.3333 8C13.3333 8.368 13.0353 8.66667 12.6667 8.66667Z"
				fill={useGradient ? `url(#${gradId})` : color}
			/>
		</Icon>
	);
};

ClockIcon.propTypes = {
	useGradient: PropTypes.bool,
	from: PropTypes.string,
	to: PropTypes.string,
	color: PropTypes.string,
};
